import React from 'react';
import PropTypes from 'prop-types';
import { TextField, InputAdornment } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { DirectionsBus } from '@material-ui/icons';
import isMobile from 'ismobilejs';

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: isMobile.phone ? 'calc(90%)' : '205',
    borderBottom: 0,
  },
  selectItem: {
    fontSize: 14,
  },
});
class TrackingCourier extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      trackingCourier: props.trackingCourier,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      trackingCourier: nextProps.trackingCourier,
    });
  }
  handleChange(order, value) {
    this.setState({ trackingCourier: value });
    this.props.setCourier(order, value);
  }

  render() {
    const { classes, order, withLabel, readOnly, carriers } = this.props;
    const { trackingCourier } = this.state;
    return (
      <TextField
        disabled={!!readOnly || order.shippingStatusLabel === 'cancelled'}
        id="select-currency-native"
        select
        className={classes.textField}
        value={trackingCourier}
        onChange={e => this.handleChange(order, e.target.value)}
        SelectProps={{
          native: true,
          MenuProps: {
            className: classes.menu,
          },
          className: classes.selectItem,
        }}
        placeholder="Select Courier"
        margin="normal"
        label={withLabel ? 'Courier' : ''}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <DirectionsBus />
            </InputAdornment>
          ),
        }}
      >
        {carriers.map(carrier => (
          <option key={carrier.name} value={carrier.name}>
            {carrier.name}
          </option>
        ))}
      </TextField>
    );
  }
}

TrackingCourier.propTypes = {
  classes: PropTypes.object.isRequired,
  setCourier: PropTypes.func.isRequired,
  trackingCourier: PropTypes.string,
  order: PropTypes.object.isRequired,
  withLabel: PropTypes.bool,
  readOnly: PropTypes.boolean,
  carriers: PropTypes.array,
};

export default withStyles(styles)(TrackingCourier);



// WEBPACK FOOTER //
// ./src/components/orders/TrackingCourier.js